import { Module } from 'vuex'
import { getSetting, getOssSignatureInfo } from '@/api/setting'
import { getStorage, setStorage } from '@/utils/storage'

export interface ISettingState {
    otherSetting: Record<string, string | number>, //设置信息
    ossSignature: Record<string, string | number>,
}

const SYS_OTHER_SETTING_KEY = 'sysOtherSetting'

const settings = {
    state: {
        ossSignature: null,
        otherSetting: null
    },
    mutations: {
        setOtherSetting (state, setting) {
            state.otherSetting = setting;
        },
        setOssSignature (state, config) {
            state.ossSignature = config;
        },
    },
    actions: {
        // 对齐学员 PC：优先读本地缓存（默认 30 分钟），未命中再请求
        async getOtherSetting ({ commit }) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise<void>(async (resolve, reject) => {
                try {
                    let settingHd = getStorage(SYS_OTHER_SETTING_KEY)
                    if (!settingHd) {
                        const setting = await getSetting() as any
                        // /api/app/config/other_setting 返回 { data: { other_setting: {...} } }
                        const payload = setting && setting.data ? setting.data : (setting || {})
                        settingHd = payload.other_setting || payload
                        setStorage(SYS_OTHER_SETTING_KEY, { ...settingHd })
                    }
                    commit("setOtherSetting", settingHd);
                    resolve();
                } catch (e) {
                    reject(e)
                }
            });
        },
        async getOssSignature ({ commit }) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise<void>(async (resolve, reject) => {
                try {
                    const config = await getOssSignatureInfo()
                    commit("setOssSignature", config);
                    resolve();
                } catch (e) {
                    reject(e)
                }
            });
        }
    }

}

export default settings as Module<ISettingState, Record<string, unknown>>
